import React, { Fragment, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import startOfDay from 'date-fns/startOfDay';

import FormGroup from '../../../../../../../components/global/FormGroup';
import Alert from '../../../../../../../components/global/Alert';
import { getFormikTouchedErrors } from '../../../../../../../util/formik';
import Label from '../../../../../../../components/global/Label';
import DatePickerWithYearDropdown from '../../../../../../../components/global/DatePickerWithYearDropdown';
import InputGroup from '../../../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../../../util/assets';
import { EVENT_DETAILS_CONTEXT } from '../utils';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    email_address: PropTypes.string,
  }),
  values: PropTypes.shape({
    name: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    event_date: PropTypes.string,
  }).isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  context: PropTypes.oneOf(Object.values(EVENT_DETAILS_CONTEXT)),
};

const BirthdayEventDetails = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  context,
}) => {
  const dateInputRef = useRef();
  const dateOfBirthInputRef = useRef();
  const errorList = Object.values(getFormikTouchedErrors(errors, touched));
  const { date } = values;

  useEffect(() => {
    if (dateInputRef?.current) {
      dateInputRef.current.readOnly = 'readonly';
    }
  }, [dateInputRef]);

  useEffect(() => {
    if (dateOfBirthInputRef?.current) {
      dateOfBirthInputRef.current.readOnly = 'readonly';
    }
  }, [dateOfBirthInputRef]);

  return (
    <Fragment>
      <FormGroup
        id="name"
        name="name"
        error={!!errors.name}
        label={
          context === EVENT_DETAILS_CONTEXT.SLIDESHOW
            ? 'Slideshow Name'
            : 'Event Name'
        }
        placeholder="Enter event name here..."
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.name}
      />
      <div className="row">
        <div className="col-12">
          <div className="row">
            <FormGroup
              id="first_name"
              name="first_name"
              error={!!errors.first_name}
              label="Name of the celebrated"
              placeholder="First name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.first_name}
              className="col-12 col-lg-6 mb-1"
            />
            <FormGroup
              id="last_name"
              name="last_name"
              error={!!errors.last_name}
              label={<>&nbsp;</>}
              labelProps={{
                className: 'd-none d-lg-block',
              }}
              className="col-12 col-lg-6"
              placeholder="Last name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.last_name}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <Label id="date" optional>
              Having a Party?
            </Label>
            <div className="datepicker-gray-light">
              <DatePickerWithYearDropdown
                id="date"
                customInput={
                  <InputGroup
                    id="date"
                    name="date"
                    error={!!errors.date}
                    type="text"
                    autoComplete="off"
                    inputRef={dateInputRef}
                    addon={
                      <img
                        alt=""
                        src={getAsset('/shutterbug/icons/calendar.svg')}
                      />
                    }
                  />
                }
                name="date"
                popperClassName="freemium-event-date-picker-popper"
                wrapperClassName="freemium-event-date-picker"
                onChange={selectedDate => {
                  handleChange({
                    target: {
                      name: 'date',
                      value: startOfDay(selectedDate),
                    },
                  });
                }}
                selected={date}
              />
            </div>
          </div>
        </div>
      </div>

      {errorList.length > 0 && (
        <Alert type="danger" className="mt-1 text-normal">
          <ul className="mb-0">
            {errorList.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Fragment>
  );
};

BirthdayEventDetails.propTypes = propTypes;

export default BirthdayEventDetails;
